import historyContext from '@/hooks/historyContext';
import { useRouter } from 'next/router';
import { ReactNode, useEffect, useState } from 'react';
type Props = {
  children: ReactNode;
};
const HistoryProvider = ({
  children
}: Props) => {
  const router = useRouter();
  const [history, setHistory] = useState([router.asPath, '']);
  useEffect(() => {
    setHistory([router.asPath, history[0]]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.asPath]);
  return <historyContext.Provider value={history}>{children}</historyContext.Provider>;
};
export default HistoryProvider;